import * as types from './action-types';

export const initialState = {
  status: 'initial',
  invoice: {
    status: 'initial',
    data: {},
    error: {}
  },
  paymentRequest: {
    status: null,
    data: {
      status: null
    },
    error: {}
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_INVOICE:
      return {
        ...state,
        invoice: {
          ...state.invoice,
          status: 'success',
          data: action.payload
        }
      };
    case types.FETCH_INVOICE:
      return {
        ...state,
        invoice: {
          ...state.invoice,
          status: 'fetching'
        }
      };
    case types.ERROR_INVOICE:
      return {
        ...state,
        invoice: {
          ...state.invoice,
          status: 'error',
          error: action.payload
        }
      };
    case types.CREATE_PAYMENT_REQUEST:
      return {
        ...state,
        paymentRequest: {
          ...state.paymentRequest,
          status: 'creating'
        }
      };
    case types.SET_PAYMENT_REQUEST:
      return {
        ...state,
        paymentRequest: {
          ...state.paymentRequest,
          status: 'success',
          data: action.payload
        }
      };
    case types.ERROR_PAYMENT_REQUEST:
      return {
        ...state,
        paymentRequest: {
          ...state.paymentRequest,
          status: 'error',
          error: action.payload
        }
      };
    case types.CREATING_INVOICE_EMAIL:
      return {
        ...state,
        invoiceEmail: {
          status: 'creating'
        }
      };
    case types.SUCCESS_INVOICE_EMAIL:
      return {
        ...state,
        invoiceEmail: {
          status: 'success'
        }
      };
    case types.ERROR_INVOICE_EMAIL:
      return {
        ...state,
        invoiceEmail: {
          status: 'error',
          error: action.payload
        }
      };
    case types.SET_STATUS:
      return {
        ...state,
        status: action.payload
      };
  }

  return state;
};



/** WEBPACK FOOTER **
 ** ./src/redux/modules/payment/reducer.js
 **/